/*jslint white: true, nomen: true */
/*global angular */
(function() {
  'use strict';

  angular.module('app.forms')
    .directive('formComponentZip', [function() {
      return {
        restrict: 'E',
        templateUrl: 'form-component-zip',
        replace: true,
        scope: {
          formObj: "=",
          formScope: "="
        },
        bindToController: true,
        controllerAs: 'vm',
        link: function() {},
        controller: ['$scope', function($scope) {
          $scope.zipPattern = (function() {
            var regexp = /^(\d{5}-\d{4}|\d{5})$/;
            return {
              test: function(value) {
                return regexp.test(value);
              }
            };
          })();
        }]
      };

    }]);
}());
